import React from 'react'
import ReactDOM from 'react-dom'

import SearchApp from './SearchApp'
import ManageBookingSearchApp from './ManageBookingSearchApp'
import ManageDelegateForm from './ManageDelegateApp'
import TabbedSearch from './TabbedSearch'
import EventSearch from './EventSearch'
import Map from './components/Map'
import VenueProposalMap from './components/VenueProposalMap'

window.React = React;
window.ReactDOM = ReactDOM;
window.SearchApp = SearchApp;
window.ManageBookingSearchApp = ManageBookingSearchApp;
window.TabbedSearch = TabbedSearch;
window.EventSearch = EventSearch;
window.PropertyMap = Map;
window.VenueProposalMap = VenueProposalMap;
window.ManageDelegateForm = ManageDelegateForm;


// WEBPACK FOOTER //
// ./src/index.js